import "./index.scss";

import classNames from "services/classNames";

const Header = ({ children, className }) => (
  <div className={classNames("header", "no-print", classNames)}>{children}</div>
);

export default Header;
